import { Util } from "Util";
import { useEffect, useRef } from "react";
import { KeyType } from "types/common/CommonType";

export const handleActionKeyPress = (
  key: keyof KeyType,
  callback: () => void
) => {
  const onPressESCKeyCheck = (event: KeyboardEvent) => {
    Util.handleKeyPress(event, key, () => callback());
  };

  const keydownListener = (e: KeyboardEvent) => onPressESCKeyCheck(e);
  document.addEventListener("keydown", keydownListener);
  return () => {
    document.removeEventListener("keydown", keydownListener);
  };
};
